import accountMemos from './accountMemos';
import billingDetails from './billingDetails';
import callAhead from './callAhead';
import customerDetails from './customerDetails';
import equipmentDetails from './equipmentDetails';
import networkDetails from './networkDetails';
import nodeOutage from './nodeOutage';
import orderDetails from './orderDetails';
import packageDetails from './packageDetails';
import sqcHistory from './sqcHistory';
import collectionDetails from './collectionDetails';
import orderServices from './orderServices';
import repeatStatus from './repeatStatus';
import charges from './charges';
import justAskDetails from './justAskDetails';
import closeCodes from './closeCodes';
import orderStatus from './orderStatus';
import commercialDetails from './commercialDetails';
import orderCloseValidation from './orderCloseValidation';
import accountOtherDetails from './accountOtherDetails';
import equipmentOptions from './equipmentOptions';
import houseEquipmentDetails from './houseEquipmentDetails';
import outletOptimizationDetails from './outletOptimizationDetails';

export default {
    accountMemos,
    billingDetails,
    callAhead,
    customerDetails,
    equipmentDetails,
    networkDetails,
    nodeOutage,
    orderDetails,
    packageDetails,
    sqcHistory,
    collectionDetails,
    orderServices,
    repeatStatus,
    charges,
    justAskDetails,
    closeCodes,
    orderStatus,
    commercialDetails,
    orderCloseValidation,
    accountOtherDetails,
    equipmentOptions,
    houseEquipmentDetails,
    outletOptimizationDetails
};



// WEBPACK FOOTER //
// ./src/store/order-details-config/index.js